import { Expr } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

const extractRefValue = (
  expression: Expr,
  parameterName: string,
  templateFieldValueResolver: (key: string) => unknown
): unknown => {
  const { params } = expression;

  if (!params || !(parameterName in params)) {
    throw new Error(`Missing ${parameterName} in parameters`);
  }

  const parameterValue = params[parameterName as keyof typeof params] as any;

  if (!parameterValue || !("ref" in parameterValue)) {
    throw new Error(`Missing ref in ${parameterName} parameter`);
  }

  const stringRefValue = String(parameterValue.ref);
  return templateFieldValueResolver(stringRefValue);
};

export const extractFieldRef = (
  expression: Expr,
  templateFieldValueResolver: (key: string) => unknown
): unknown => {
  return extractRefValue(expression, "fieldValue", templateFieldValueResolver);
};

export const extractOtherRef = (
  expression: Expr,
  templateFieldValueResolver: (key: string) => unknown
): unknown => {
  return extractRefValue(expression, "otherValue", templateFieldValueResolver);
};

// Utility functions for dependency extraction (no resolver needed)
const extractRefString = (
  expression: Expr,
  parameterName: string
): string | null => {
  const { params } = expression;

  if (!params || !(parameterName in params)) {
    return null;
  }

  const parameterValue = params[parameterName as keyof typeof params] as any;

  if (!parameterValue || !("ref" in parameterValue)) {
    return null;
  }

  const ref = parameterValue.ref;
  return typeof ref === "string" ? ref : String(ref);
};

const extractFieldRefString = (expression: Expr): string | null => {
  return extractRefString(expression, "fieldValue");
};

export const extractRefsFromExpressions = (expressions: Expr[]): string[] => {
  return expressions
    .map((expr) => extractFieldRefString(expr))
    .filter((ref): ref is string => ref !== null);
};
